module.exports = __webpack_public_path__ + "static/media/bandwidth_thumb_home.aa823962.jpg";